import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart",
  "use": "heart-usage",
  "viewBox": "0 0 12 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 11\" id=\"heart\"><path d=\"M10.507 1.275a3.17 3.17 0 0 0-4.51 0 3.17 3.17 0 0 0-4.51 0 3.235 3.235 0 0 0 0 4.543l4.123 4.15a.546.546 0 0 0 .773 0l4.124-4.15a3.22 3.22 0 0 0 0-4.543\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol